var ref;
export var isWindowUserAgentCinchApp = "object" !== "undefined" && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
